import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0af1110f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "goals-unlock-box"
};
const _hoisted_2 = {
  class: "goals-tit"
};
const _hoisted_3 = {
  class: "goals-list"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "goal-top-tips"
}, "众筹成功结束时，您将获得全部已达成的专属奖励!", -1));
const _hoisted_5 = {
  class: "goals-left"
};
const _hoisted_6 = {
  key: 0,
  class: "goal_icon_status",
  src: "https://p6.moimg.net/md/icon/pro_goal_unlock_done.png"
};
const _hoisted_7 = {
  key: 1,
  class: "goal_icon_status",
  src: "https://p6.moimg.net/md/icon/pro_goal_unlock_ing.png"
};
const _hoisted_8 = {
  key: 2,
  class: "goal_icon_status goal_icon_circle"
};
const _hoisted_9 = {
  class: "goals-right"
};
const _hoisted_10 = {
  class: "goal_all_status"
};
const _hoisted_11 = {
  class: "goal_title"
};
const _hoisted_12 = {
  class: "goal_money"
};
const _hoisted_13 = {
  key: 0,
  class: "goal_text_status goal_text_status_true"
};
const _hoisted_14 = {
  key: 1,
  class: "goal_text_status goal_text_status_false"
};
const _hoisted_15 = {
  class: "goal_content"
};
const _hoisted_16 = {
  key: 0,
  class: "goal_first"
};
const _hoisted_17 = {
  class: "goal_conditions_item_decs"
};
const _hoisted_18 = {
  key: 0,
  class: "goal_conditions_item_btn goal_conditions_item_btn_img",
  src: "https://p6.moimg.net/md/icon/pro_goal_unlock_task_done.png"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  key: 2,
  class: "goal_content_tips"
};
const _hoisted_21 = {
  class: "goal_prizes_item_img"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, "赠", -1));
const _hoisted_23 = {
  class: "goal_prizes_item_cont"
};
const _hoisted_24 = {
  class: "tit"
};
const _hoisted_25 = {
  class: "num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_CompGoalsUnlockHelp = _resolveComponent("CompGoalsUnlockHelp");
  const _component_CompPopupBottom = _resolveComponent("CompPopupBottom");
  return _openBlock(), _createBlock(_component_CompPopupBottom, {
    show: $props.show
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
      class: "help",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.showHelp && $options.showHelp(...args))
    }), _createTextVNode(" " + _toDisplayString($options.title) + " ", 1), _createElementVNode("i", {
      class: "close",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.closePopup && $options.closePopup(...args))
    })]), _createElementVNode("div", _hoisted_3, [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.goalUnlockList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "goals-item"
      }, [_createElementVNode("div", _hoisted_5, [item.status == 200 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : $options.getIng(item) ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("div", _hoisted_8))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(item.title || "目标"), 1), _createElementVNode("span", _hoisted_12, "￥" + _toDisplayString($options.fNum(item.amount)), 1)]), item.status == 200 ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($data.statusMap[item.status]), 1)) : $options.getIng(item) || item.status == 300 ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($data.statusMap[item.status]), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [item.promise ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.promise), 1)) : _createCommentVNode("", true), item.conditions && item.conditions.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(item.conditions, (cItem, cIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "goal_conditions_item",
          key: cIndex
        }, [_createElementVNode("div", _hoisted_17, _toDisplayString(item.conditions.length > 1 ? cIndex + 1 + '. ' : '') + " " + _toDisplayString(cItem.desc), 1), item.status != 300 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [cItem.is_completed == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_18)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "goal_conditions_item_btn",
          onClick: $event => $options.taskAction(cItem.type, cItem.reward_ids && cItem.reward_ids.length ? cItem.reward_ids[0] : '')
        }, _toDisplayString($data.conditionsBtnMap[cItem.type]), 9, _hoisted_19))], 64)) : _createCommentVNode("", true)]);
      }), 128)) : _createCommentVNode("", true), item.goal_id ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($data.giveawayTypeMap[$props.giveaway_type]), 1)) : _createCommentVNode("", true), item.prizes && item.prizes.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 3
      }, _renderList(item.prizes, (pItem, pIndex) => {
        return _openBlock(), _createElementBlock("div", {
          class: "goal_prizes_item",
          key: pIndex
        }, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_van_image, {
          onClick: $event => $options.showBig(pItem.img),
          src: _ctx.$imgUrlFilter(pItem.img, 208),
          class: "img",
          fit: "cover"
        }, null, 8, ["onClick", "src"]), _hoisted_22]), _createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString(pItem.title), 1), _createElementVNode("span", _hoisted_25, "X" + _toDisplayString(pItem.num), 1)])]);
      }), 128)) : _createCommentVNode("", true)])])]);
    }), 128))])]), _createVNode(_component_CompGoalsUnlockHelp, {
      show: $data.showUnlockGoalHelp,
      "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.showUnlockGoalHelp = $event)
    }, null, 8, ["show"])]),
    _: 1
  }, 8, ["show"]);
}